<template>
  <div class="form-day">
    <datepicker :placeholder="placeholder" format="dd/MM/yyyy" v-model="model.date" />
    <div class="form-day__select">
      <select v-model="model.moment">
        <option value="morning">{{ $t(`message.modal.request.morning`) }}</option>
        <option value="afternoon">{{ $t(`message.modal.request.afternoon`) }}</option>
      </select>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import Datepicker from 'vuejs-datepicker'
export default {
  name: 'ElementFormDay',
  props: {
    placeholder: {
      type: String,
      required: true
    },
    selectedValue: {
      type: String,
      required: true
    }
  },
  components: {
    Datepicker
  },
  data () {
    return {
      model: {
        date: '',
        moment: ''
      }
    }
  },
  watch: {
    model: {
      deep: true,
      handler () {
        this.$emit('change', {
          date: this.model.date !== '' ? moment(this.model.date).format('DD/MM/YYYY') : '',
          moment: this.model.moment
        })
      }
    }
  },
  mounted () {
    this.model.moment = this.selectedValue
  }
}
</script>

<style lang="scss">
.form-day{
  display: flex;
  justify-content: flex-start;
  align-items: stretch;

  > div{
    flex: 0 1 auto;
    width: 100%;

    &:not(:last-of-type){
      margin-right: layout("spacing");
    }
  }

  input, select{
    margin: 0;
  }

  &__select{
    @include custom-select;
  }

  .vdp-datepicker{
    @include icon(icons("events"));
    position: relative;

    &__calendar{
      width: 100%;

      .month{
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    &:before{
      position: absolute;
      right: 1rem;
      top: 50%;
      transform: translateY(-50%);
      color: colors('primary');
      display: block;
      // width: 2rem;
      // height: 2rem;
      font-size: 1.9rem;
    }
    div:first-child{
      height: 100%;
      input{
        height: 100%;
      }
    }
  }

}
</style>
